/**
 * User Supervisor Mapping Interfaces
 */

/**
 * Excel header for user hierarchy import template
 */
export interface UserHierarchyExcelHeader {
  [key: string]: string;
}

/**
 * API response for getting excel headers
 */
export interface UserHierarchyExcelHeadersApiResponse {
  status: number;
  message: string;
  data: UserHierarchyExcelHeader;
}

/**
 * Import response data
 */
export interface UserHierarchyImportData {
  messages: string;
  count_sucess_supervisor: number;
  count_sucess_enduser: number;
}

/**
 * API response for importing user hierarchy
 */
export interface UserHierarchyImportApiResponse {
  status: number;
  message: string;
  data: UserHierarchyImportData;
}

/**
 * API response for exporting user hierarchy (returns download URL)
 */
export interface UserHierarchyExportApiResponse {
  status: number;
  message: string;
  data: string; // URL to download file
}
